import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const YoutubeIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="32"
            height="26"
            viewBox="0 0 32 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M31.2688 4.1968C32 7.048 32 13 32 13C32 13 32 18.952 31.2688 21.8032C30.8624 23.3792 29.6736 24.6192 28.168 25.0384C25.4336 25.8 16 25.8 16 25.8C16 25.8 6.5712 25.8 3.832 25.0384C2.32 24.6128 1.1328 23.3744 0.7312 21.8032C4.76837e-08 18.952 0 13 0 13C0 13 4.76837e-08 7.048 0.7312 4.1968C1.1376 2.6208 2.3264 1.3808 3.832 0.961597C6.5712 0.199997 16 0.199997 16 0.199997C16 0.199997 25.4336 0.199997 28.168 0.961597C29.68 1.3872 30.8672 2.6256 31.2688 4.1968ZM12.8 18.6L22.4 13L12.8 7.4V18.6Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default YoutubeIcon;

